import React from 'react';
import { CheckCircle2, XCircle } from 'lucide-react';
import { FadeIn } from '../ui/FadeIn';
export function Audience() {
  const isFor = ['Mujeres de 40 a 65+ años que sufren de sofocos e insomnio.', 'Mujeres que sienten su abdomen inflamado sin importar lo que coman.', "Profesionales que necesitan eliminar la 'neblina mental' para rendir en el trabajo.", 'Quienes buscan una solución natural, sin fármacos pesados ni hormonas sintéticas.'];
  const isNotFor = ["Personas que buscan una 'pastilla mágica' sin cambiar un solo hábito nocturno.", 'Mujeres menores de 35 años que no presentan síntomas hormonales.', 'Aquellas que no están dispuestas a seguir un protocolo sencillo de 16 horas.'];
  return <section className="py-20 md:py-32 px-4 bg-brand-beige" data-id="element-1">
      <div className="max-w-6xl mx-auto" data-id="element-2">
        <FadeIn data-id="element-3">
          <div className="text-center mb-16" data-id="element-4">
            <h2 className="text-3xl md:text-4xl font-bold text-brand-dark mb-4" data-id="element-5">
              ¿Es este protocolo para ti?
            </h2>
            <p className="text-lg text-brand-dark/70" data-id="element-6">
              La claridad es fundamental. Descubre si este sistema se adapta a
              tu situación actual.
            </p>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12" data-id="element-7">
          {/* Who this is for */}
          <FadeIn delay={0.1} direction="right" data-id="element-8">
            <div className="bg-white rounded-3xl p-8 md:p-10 shadow-sm border-t-4 border-brand-sage h-full" data-id="element-9">
              <h3 className="text-2xl font-bold text-brand-dark mb-8 flex items-center gap-3" data-id="element-10">
                <CheckCircle2 className="w-8 h-8 text-brand-sage" data-id="element-11" />
                Para quién SÍ es
              </h3>
              <ul className="space-y-6" data-id="element-12">
                {isFor.map((text, index) => <li key={index} className="flex items-start gap-4" data-id="element-13">
                    <CheckCircle2 className="w-6 h-6 text-brand-sage flex-shrink-0 mt-0.5" data-id="element-14" />
                    <span className="text-brand-dark/80 text-lg" data-id="element-15">{text}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          {/* Who this is not for */}
          <FadeIn delay={0.2} direction="left" data-id="element-16">
            <div className="bg-white rounded-3xl p-8 md:p-10 shadow-sm border-t-4 border-brand-error h-full" data-id="element-17">
              <h3 className="text-2xl font-bold text-brand-dark mb-8 flex items-center gap-3" data-id="element-18">
                <XCircle className="w-8 h-8 text-brand-error" data-id="element-19" />
                Para quién NO es
              </h3>
              <ul className="space-y-6" data-id="element-20">
                {isNotFor.map((text, index) => <li key={index} className="flex items-start gap-4" data-id="element-21">
                    <XCircle className="w-6 h-6 text-brand-error flex-shrink-0 mt-0.5" data-id="element-22" />
                    <span className="text-brand-dark/80 text-lg" data-id="element-23">{text}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}